<template>
    <section class="outer">
        <slot></slot>
    </section>
</template>
<script>
export default {
    name: 'OuterSectionV2'
}
</script>
<style lang="scss" scoped>
    @import "@/assets/css/global.scss";
    body.theme-light {
        section.outer {
            // height: 776px;
            background: #FFFFFF;
            box-shadow: 0px 42px 118px rgba(81, 112, 117, 0.14);
            border-radius: 17px;
            padding: 0px 50px;
            margin-bottom: 32px;
            position: relative;
        }
    }
    body.theme-dark {
        section.outer {
            // height: 776px;
            background: #3B484A;
            box-shadow: 0px 42px 118px rgba(81, 112, 117, 0.14);
            border-radius: 17px;
            padding: 0px 50px;
            margin-bottom: 32px;
            position: relative;

        }
    }
</style>